import React from "react";
import { useSelector } from "react-redux";
import HelmetWrapper from "../../HelmetWrapper";
import { selectAuth } from "../../components/auth/auth.selector";
import "../../styles/unpaid-renewal-expiring/unpaid-members.css";
import UREStructure from "./UREStructure";

const URE = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  return (
    <HelmetWrapper title="WTF: Renewal/Expiring/Unpaid Members">
      <UREStructure userInfoData={userInfoData} />
    </HelmetWrapper>
  );
};

export default URE;
